export default __webpack_public_path__ + "static/media/landing_new_img2.2dd8c63f.svg";